// ContactForm.js
import React from "react";
import "./ContactForm.css";

function ContactForm() {
  return (
    <section className="contact-section">
      <div className="contact-container">
        <h2>Get in Touch</h2>
        <p>We’d love to hear about your project. Send us a message below.</p>

        <form
          name="contact"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          action="/thank-you"
          className="contact-form"
        >
          {/* Required by Netlify */}
          <input type="hidden" name="form-name" value="contact" />
          {/* Honeypot anti-spam */}
          <p style={{ display: "none" }}>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>

          <div className="form-group">
            <label htmlFor="first-name">First Name *</label>
            <input type="text" id="first-name" name="firstName" required />
          </div>

          <div className="form-group">
            <label htmlFor="last-name">Last Name *</label>
            <input type="text" id="last-name" name="lastName" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input type="email" id="email" name="email" required />
          </div>

          <div className="form-group">
            <label htmlFor="location">Location *</label>
            <small className="form-hint">
              Please include your city / state / country location.
            </small>
            <input type="text" id="location" name="location" required />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <small className="form-hint">
              Please share some background or outline project details.
            </small>
            <textarea id="message" name="message" rows="5" required></textarea>
          </div>

          <button type="submit" className="contact-btn">SEND MESSAGE</button>
        </form>
      </div>
    </section>
  );
}

export default ContactForm;
